var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chip',{attrs:{"small":"","label":"","ripple":false,"color":"var(--v-resRed-darken1)","text-color":"white"}},[_vm._v(" EXP ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }